/* Amavil – comportamiento de secciones personalizadas (amv-*) */
(function () {
  const pad = (n) => String(n).padStart(2, '0');

  // Fecha objetivo: fecha fija (data-end) o fin del día / ciclo de N horas (evergreen)
  function getTarget(el) {
    const end = el.dataset.end ? Date.parse(el.dataset.end.replace(' ', 'T')) : NaN;
    if (!isNaN(end) && end > Date.now()) return end;
    const hours = parseFloat(el.dataset.hours || '0');
    if (hours > 0) {
      const cycle = hours * 3600000;
      return Math.ceil(Date.now() / cycle) * cycle;
    }
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }

  function startCountdown(el) {
    if (el.dataset.amvInit) return;
    el.dataset.amvInit = '1';
    let target = getTarget(el);
    const h = el.querySelector('[data-h]');
    const m = el.querySelector('[data-m]');
    const s = el.querySelector('[data-s]');
    const tick = () => {
      let diff = target - Date.now();
      if (diff <= 0) {
        target = getTarget(el);
        diff = Math.max(0, target - Date.now());
      }
      const total = Math.floor(diff / 1000);
      const hh = Math.floor(total / 3600);
      const mm = Math.floor((total % 3600) / 60);
      const ss = total % 60;
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
      if (!h && !m && !s) el.textContent = `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
    };
    tick();
    setInterval(tick, 1000);
  }

  function startSold(el) {
    if (el.dataset.amvInit) return;
    el.dataset.amvInit = '1';
    const value = Math.min(100, Math.max(0, parseFloat(el.dataset.percent || '0')));
    const fill = el.querySelector('.amv-p-sold__fill');
    const label = el.querySelector('[data-percent-label]');
    requestAnimationFrame(() => {
      if (fill) fill.style.width = value + '%';
    });
    if (label) label.textContent = Math.round(value);
  }

  // Puntos de los sliders: indican la tarjeta visible y permiten saltar a ella
  function startDots(dots) {
    if (dots.dataset.amvInit) return;
    dots.dataset.amvInit = '1';
    const track = document.getElementById(dots.getAttribute('aria-controls'));
    if (!track) return;
    const buttons = [...dots.querySelectorAll('button')];
    const update = () => {
      const left = track.getBoundingClientRect().left;
      let active = 0;
      let best = Infinity;
      [...track.children].forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - left);
        if (distance < best) {
          best = distance;
          active = index;
        }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) active = buttons.length - 1;
      buttons.forEach((button, index) => button.classList.toggle('is-active', index === active));
    };
    track.addEventListener('scroll', update, { passive: true });
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const card = track.children[index];
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-amv-countdown]').forEach(startCountdown);
    root.querySelectorAll('[data-amv-dots]').forEach(startDots);
    root.querySelectorAll('[data-amv-sold]').forEach(startSold);
    initGalleryArrows(root);
    if (root.querySelectorAll) initMirrors(root);
  }
  window.amvInit = init;

  // CTA de la página de producto: subir a la ficha (bundles y botón) sin recargar
  function scrollToBuy() {
    const scope = document.querySelector('.amv-product') || document.body;
    const visible = (el) => el && el.getBoundingClientRect().height > 0;
    const target = ['.amv-p-offer-title', 'kaching-bundle', 'product-form']
      .map((selector) => scope.querySelector(selector))
      .find(visible);
    const header = document.querySelector('.section-header');
    const offset = (header ? header.getBoundingClientRect().height : 0) + 12;
    const top = (target || scope).getBoundingClientRect().top + window.scrollY - offset;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', (event) => {
    const buy = event.target.closest('[data-amv-scroll-buy]');
    if (buy) {
      event.preventDefault();
      scrollToBuy();
      return;
    }
    const nav = event.target.closest('[data-amv-slide]');
    if (nav) {
      const slider = document.getElementById(nav.getAttribute('aria-controls'));
      if (slider) {
        const card = slider.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + 14 : slider.clientWidth;
        slider.scrollBy({ left: nav.dataset.amvSlide === 'prev' ? -step : step, behavior: 'smooth' });
      }
      return;
    }
    const opener = event.target.closest('[data-amv-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.amvOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-amv-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (event.target.matches && event.target.matches('dialog.amv-modal')) event.target.close();
  });

  // ---------- Carrito: refrescar contador y drawer al volver con el botón "atrás" (bfcache)
  function refreshCart() {
    if (window.location.pathname === (window.routes && window.routes.cart_url)) {
      window.location.reload();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    const ids = drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
    Promise.all([
      fetch(`${window.location.pathname}?sections=${ids}`).then((r) => r.json()),
      fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`).then((r) => r.json()),
    ])
      .then(([json, cart]) => {
        const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleHtml = json['cart-icon-bubble'] && parse(json['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHtml) bubble.innerHTML = bubbleHtml.innerHTML;
        if (drawer && json['cart-drawer']) {
          const inner = parse(json['cart-drawer'], '.drawer__inner');
          const current = drawer.querySelector('.drawer__inner');
          if (inner && current) current.innerHTML = inner.innerHTML;
          drawer.classList.toggle('is-empty', cart.item_count === 0);
        }
      })
      .catch(() => {});
  }
  window.addEventListener('pageshow', (event) => {
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (event.persisted || (nav && nav.type === 'back_forward')) refreshCart();
  });

  // ---------- Añadir al carrito: abrir el drawer al instante mientras el carrito responde
  let loadingTimer;
  function stopCartLoading() {
    clearTimeout(loadingTimer);
    document.querySelector('cart-drawer')?.classList.remove('amv-cart-loading');
  }
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !form.closest || !form.closest('product-form')) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      drawer.classList.add('amv-cart-loading');
      if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
      clearTimeout(loadingTimer);
      loadingTimer = setTimeout(stopCartLoading, 10000);
    },
    true
  );
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(stopCartLoading, 50));
    subscribe(PUB_SUB_EVENTS.cartError, () => {
      const drawer = document.querySelector('cart-drawer');
      stopCartLoading();
      if (drawer && typeof drawer.close === 'function') drawer.close();
    });
  }

  // ---------- Galería de producto: flechas sobre la imagen principal
  function initGalleryArrows(root) {
    root.querySelectorAll('.amv-product media-gallery, .amv-mirror media-gallery').forEach((gallery) => {
      if (gallery.dataset.amvArrows) return;
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const thumbs = () => [...gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')];
      if (!viewer || thumbs().length < 2) return;
      gallery.dataset.amvArrows = '1';
      const go = (dir) => {
        const list = thumbs();
        let index = list.findIndex((b) => b.getAttribute('aria-current') === 'true');
        if (index < 0) index = 0;
        const next = list[(index + dir + list.length) % list.length];
        next.click();
        next.closest('.thumbnail-list__item')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      };
      const icon = (d) =>
        `<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="${d}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      [
        ['prev', 'Imagen anterior', 'M10.5 2.5L5 8l5.5 5.5', -1],
        ['next', 'Imagen siguiente', 'M5.5 2.5L11 8l-5.5 5.5', 1],
      ].forEach(([name, label, path, dir]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `amv-gallery-arrow amv-gallery-arrow--${name}`;
        button.setAttribute('aria-label', label);
        button.innerHTML = icon(path);
        button.addEventListener('click', (e) => {
          e.preventDefault();
          go(dir);
        });
        viewer.appendChild(button);
      });
    });
  }

  // ---------- Ficha de producto espejo (homepage): copia la sección principal de la página de producto
  function cloneScript(source) {
    const script = document.createElement('script');
    [...source.attributes].forEach((attr) => script.setAttribute(attr.name, attr.value));
    script.textContent = source.textContent;
    return script;
  }

  async function loadMirror(el) {
    if (el.dataset.amvLoaded) return;
    el.dataset.amvLoaded = '1';
    const target = el.querySelector('.amv-mirror__target');
    try {
      const response = await fetch(el.dataset.url, { credentials: 'same-origin' });
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section =
        doc.querySelector('.shopify-section.amv-product') ||
        doc.querySelector('[id^="shopify-section-template--"][id$="__main"]');
      if (!section) throw new Error('Sección de producto no encontrada');

      // Datos que las apps (p. ej. Kaching Bundles) leen de la cabecera de la página de producto
      doc.head.querySelectorAll('script[type="application/json"]').forEach((json) => {
        const id = json.id;
        const cls = json.getAttribute('class') || '';
        if (!id && !/kaching|bundle/i.test(cls)) return;
        if (id && document.getElementById(id)) return;
        document.head.appendChild(cloneScript(json));
      });

      const node = document.importNode(section, true);
      node.querySelectorAll('product-info').forEach((info) => info.setAttribute('data-update-url', 'false'));
      node.querySelectorAll('.product__title h1').forEach((h1) => {
        const h2 = document.createElement('h2');
        h2.className = h1.className || 'h1';
        h2.innerHTML = h1.innerHTML;
        h1.replaceWith(h2);
      });
      // Solo los scripts ejecutables; los JSON (datos de variantes, etc.) se quedan en su sitio
      const executable = [...node.querySelectorAll('script')].filter(
        (script) => !script.type || /javascript|module/i.test(script.type)
      );
      const external = executable.filter((script) => script.src);
      const inline = executable.filter((script) => !script.src);
      external.forEach((script) => script.remove());
      target.innerHTML = '';
      target.appendChild(node);

      const loaded = new Set([...document.scripts].map((script) => script.src).filter(Boolean));
      for (const script of external) {
        if (loaded.has(script.src)) continue;
        await new Promise((resolve) => {
          const fresh = cloneScript(script);
          fresh.removeAttribute('defer');
          fresh.onload = fresh.onerror = resolve;
          document.body.appendChild(fresh);
        });
      }
      inline.forEach((script) => script.replaceWith(cloneScript(script)));
      init(node);
      // Apps que pintan su bloque con JS: se les pide que se inicien sobre la ficha nueva
      if (typeof window.kachingBundlesInitialize === 'function') window.kachingBundlesInitialize();
      document.dispatchEvent(new CustomEvent('amv:mirror:loaded', { detail: { element: node } }));
    } catch (error) {
      console.error(error);
      target.innerHTML = `<div class="page-width amv-center"><a class="amv-btn" href="${el.dataset.url}">Ver producto</a></div>`;
    }
  }

  function initMirrors(root) {
    root.querySelectorAll('[data-amv-mirror]').forEach(loadMirror);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
